export interface OhsAttachment {
  _id?: string;
  url?: string;
  downloadUrl?: string;
  isDeleted?: boolean;
  type?: string;
  id: string;
  key: string;
  bucket: string;
  fileName: string;
  size: number;
  mimeType: string;
  dateUploaded: string;
  tzDateCreated: string;
}

export enum OhsFileState {
  InProgress = 'inprogress',
  Paused = 'paused',
  Completed = 'completed',
  Deleted = 'deleted',
}

export type OhsPresignedFile = {
  id: string;
  _id?: string;
  name: string;
  file?: File;
  progress: number;
  isMultipart?: boolean;
  upload?: {
    pause: () => void;
    resume: () => void;
  };
  state: OhsFileState;
  details: string;
  tzDateCreated: string;
};
